import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from '../../lib/toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const inputCls = 'w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:border-emerald-400 focus:outline-none';

// إعدادات التواصل عبر واتساب — تُستخدم داخل إعدادات المنشأة وداخل صفحة «التواصل»
export const WhatsAppSettingsForm = () => {
  const [form, setForm] = useState({
    whatsapp_number: '', whatsapp_country_code: '966', whatsapp_display_name: '',
    whatsapp_signature: '', whatsapp_contact_hours: '', whatsapp_enabled: false,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/club-settings`, auth())
      .then((res) => setForm((f) => ({ ...f, ...res.data })))
      .catch(() => toast.error('تعذّر تحميل إعدادات التواصل'))
      .finally(() => setLoading(false));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API}/club-settings`, form, auth());
      toast.success('تم حفظ إعدادات التواصل');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'تعذّر حفظ الإعدادات');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-8"><span className="h-6 w-6 animate-spin rounded-full border-2 border-emerald-500 border-t-transparent" /></div>;
  }

  return (
    <form onSubmit={save} className="space-y-4 max-w-xl" data-testid="whatsapp-settings-form">
      <div className="flex items-center justify-between rounded-xl border border-slate-200 p-3">
        <div>
          <p className="text-sm font-bold text-slate-800">تفعيل التواصل عبر واتساب</p>
          <p className="text-xs text-slate-500">يظهر زر التواصل لولي الأمر فقط عند التفعيل ووجود رقم رسمي</p>
        </div>
        <label className="relative inline-flex cursor-pointer items-center">
          <input
            type="checkbox"
            checked={!!form.whatsapp_enabled}
            onChange={(e) => setForm({ ...form, whatsapp_enabled: e.target.checked })}
            data-testid="whatsapp-enabled-toggle"
            className="peer sr-only"
          />
          <div className="h-6 w-11 rounded-full bg-slate-200 peer-checked:bg-emerald-600 transition-colors" />
          <div className="absolute right-1 top-1 h-4 w-4 rounded-full bg-white transition-transform peer-checked:-translate-x-5" />
        </label>
      </div>

      <div>
        <label className="mb-1 block text-xs font-semibold text-slate-600">رقم واتساب الرسمي للمنشأة</label>
        <input
          value={form.whatsapp_number || ''}
          onChange={(e) => setForm({ ...form, whatsapp_number: e.target.value })}
          placeholder="05XXXXXXXX"
          dir="ltr"
          data-testid="whatsapp-number-input"
          className={inputCls}
        />
      </div>

      <div>
        <label className="mb-1 block text-xs font-semibold text-slate-600">رمز الدولة الافتراضي</label>
        <input
          value={form.whatsapp_country_code || ''}
          onChange={(e) => setForm({ ...form, whatsapp_country_code: e.target.value })}
          placeholder="966"
          dir="ltr"
          data-testid="whatsapp-country-code-input"
          className={inputCls}
        />
      </div>

      <div>
        <label className="mb-1 block text-xs font-semibold text-slate-600">اسم المنشأة المستخدم في الرسائل</label>
        <input
          value={form.whatsapp_display_name || ''}
          onChange={(e) => setForm({ ...form, whatsapp_display_name: e.target.value })}
          data-testid="whatsapp-display-name-input"
          className={inputCls}
        />
      </div>

      <div>
        <label className="mb-1 block text-xs font-semibold text-slate-600">التوقيع الافتراضي (يُضاف تلقائياً في نهاية الرسائل)</label>
        <textarea
          value={form.whatsapp_signature || ''}
          onChange={(e) => setForm({ ...form, whatsapp_signature: e.target.value })}
          rows={2}
          data-testid="whatsapp-signature-input"
          className={inputCls}
        />
      </div>

      <div>
        <label className="mb-1 block text-xs font-semibold text-slate-600">أوقات التواصل</label>
        <input
          value={form.whatsapp_contact_hours || ''}
          onChange={(e) => setForm({ ...form, whatsapp_contact_hours: e.target.value })}
          placeholder="مثال: 9 صباحاً - 9 مساءً"
          data-testid="whatsapp-contact-hours-input"
          className={inputCls}
        />
      </div>

      <button
        type="submit"
        disabled={saving}
        data-testid="whatsapp-settings-save-button"
        className="rounded-lg bg-emerald-600 px-5 py-2.5 text-sm font-bold text-white hover:bg-emerald-700 disabled:opacity-50"
      >
        {saving ? 'جارٍ الحفظ...' : 'حفظ إعدادات التواصل'}
      </button>
    </form>
  );
};
